module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors
    },
    on: {
      "save": _vm.fetchOrderStatuses
    }
  }, [_c('div', {
    staticClass: "l-row",
    attrs: {
      "slot": "auth"
    },
    slot: "auth"
  }, [_c('form-group', {
    attrs: {
      "label": "Ambiente",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.environment),
      expression: "config.auth.environment"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.auth, "environment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "sandbox"
    }
  }, [_vm._v("Sandbox")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "production"
    }
  }, [_vm._v("Produção")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Url do painel de administração"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.url),
      expression: "config.auth.url"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "www.seusite.com.br/wm-admin"
    },
    domProps: {
      "value": (_vm.config.auth.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Token",
      "error": _vm.getError('auth.token')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.token),
      expression: "config.auth.token"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "Digite seu token"
    },
    domProps: {
      "value": (_vm.config.auth.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "token", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Esse token pode ser encontrado no painel administrativo da Moovin.")])])], 1), _vm._v(" "), _c('div', [_c('panel', {
    attrs: {
      "title": "Configurações Gerais"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Nome da Loja"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.general.origin),
      expression: "config.general.origin"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "MinhaLoja"
    },
    domProps: {
      "value": (_vm.config.general.origin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.general, "origin", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Máscara dos Telefones"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.general.phoneMask),
      expression: "config.general.phoneMask"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.general, "phoneMask", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("(51) 999999999")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "(51) 9 9999-9999"
    }
  }, [_vm._v("(51) 9 9999-9999")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "(51) 99999-9999"
    }
  }, [_vm._v("(51) 99999-9999")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "(51) 99999 9999"
    }
  }, [_vm._v("(51) 99999 9999")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "(51)999999999"
    }
  }, [_vm._v("(51)999999999")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51 999999999"
    }
  }, [_vm._v("51 999999999")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51 9 9999-9999"
    }
  }, [_vm._v("51 9 9999-9999")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51 99999-9999"
    }
  }, [_vm._v("51 99999-9999")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51 99999 9999"
    }
  }, [_vm._v("51 99999 9999")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51999999999"
    }
  }, [_vm._v("51999999999")])]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Esta configuração informa o padrão do formato dos números de telefone nos pedidos, além disto, caso algum telefone venha sem a informação ou incompleto o mesmo será substituído pela máscara selecionada. Padrão: (51) 999999999")])])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Notificações"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "URL",
      "columns": 12
    }
  }, [_vm._v("\n          " + _vm._s(_vm.urlNotification) + "\n\n          "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.urlNotification),
      expression: "urlNotification",
      arg: "copy"
    }],
    staticClass: "btn btn--sm btn--info copy hint hint--top",
    attrs: {
      "type": "button",
      "data-label": "Clique para copiar"
    },
    on: {
      "click": function($event) {
        return _vm.copied()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-copy2"
  })])])], 1)])], 1), _vm._v(" "), _c('div', [_c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Sincronizar produtos automaticamente"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.synchronize),
      expression: "config.product.synchronize"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.product.synchronize) ? _vm._i(_vm.config.product.synchronize, null) > -1 : (_vm.config.product.synchronize)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.product.synchronize,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.product, "synchronize", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.product, "synchronize", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.product, "synchronize", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os produtos da fonte de dados devem ser sincronizados automaticamente.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Sincronizar apenas produtos ativos"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.lookupOnlyStatusActive),
      expression: "config.product.lookupOnlyStatusActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.product.lookupOnlyStatusActive) ? _vm._i(_vm.config.product.lookupOnlyStatusActive, null) > -1 : (_vm.config.product.lookupOnlyStatusActive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.product.lookupOnlyStatusActive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.product, "lookupOnlyStatusActive", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.product, "lookupOnlyStatusActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.product, "lookupOnlyStatusActive", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se apenas produtos ativos na fonte de dados devem ser sincronizados.")])])], 1) : _vm._e(), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Utilizar versão 2.0 de envio de estoques"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.stockV2),
      expression: "config.product.stockV2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.product.stockV2) ? _vm._i(_vm.config.product.stockV2, null) > -1 : (_vm.config.product.stockV2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.product.stockV2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.product, "stockV2", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.product, "stockV2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.product, "stockV2", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("* Marcar apenas para lojas teste")])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Formato da cor"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.formatColor),
      expression: "config.product.formatColor"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.product, "formatColor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "colors"
    }
  }, [_vm._v("Cor Primária/Cor Secundária")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manufacturerColor"
    }
  }, [_vm._v("Cor fabricante padrão Placemarket")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manufacturerColorSource"
    }
  }, [_vm._v("Cor fabricante padrão Moovin")])]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("O padrão Placemarket irá trocar a \"/\" por \", \".")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Tipo da imagem"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.imageType),
      expression: "config.product.imageType"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.product, "imageType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.imageTypes), function(imageType) {
    return _c('option', {
      key: imageType.value,
      domProps: {
        "value": imageType.value
      }
    }, [_vm._v(_vm._s(imageType.label))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("O padrão Placemarket é original.")])])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Status de pedidos"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('a', {
    staticClass: "btn btn--info",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.fetchOrderStatuses()
      }
    }
  }, [_c('i', {
    staticClass: "icon-spinner11"
  })])]), _vm._v(" "), (_vm.fetched) ? _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.getStatusByIdentifier('default')), function(statusValue, statusName) {
    return (statusName !== 'identifier') ? _c('form-group', {
      key: statusName,
      attrs: {
        "label": _vm.$t((statusName + ".label"))
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.getStatusByIdentifier('default')[statusName]),
        expression: "getStatusByIdentifier('default')[statusName]"
      }],
      staticClass: "form-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.getStatusByIdentifier('default'), statusName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType[(statusName === 'refunded') ? 'delivered' : statusName]), function(status) {
      return _c('option', {
        key: status.code,
        domProps: {
          "value": status.code
        }
      }, [_vm._v(_vm._s(status.label))])
    }), _vm._v(" "), _vm._l((_vm.statusesGroupedByType['canceled']), function(status) {
      return (statusName === 'refunded') ? _c('option', {
        key: status.code,
        domProps: {
          "value": status.code
        }
      }, [_vm._v(_vm._s(status.label))]) : _vm._e()
    })], 2)]) : _vm._e()
  }), 1) : (!_vm.fetching) ? _c('div', {
    staticClass: "u-bolder t-error u-textCenter"
  }, [_vm._v("Não foi possível buscar os status dos pedidos da Moovin.")]) : _vm._e()], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Status de pedidos por marketplace"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('a', {
    staticClass: "btn btn--info",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.fetchOrderStatuses()
      }
    }
  }, [_c('i', {
    staticClass: "icon-spinner11"
  })])]), _vm._v(" "), _c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _vm._l((_vm.modulesInstalled), function(module) {
    return _c('panel', {
      key: module,
      staticClass: "blue-panel",
      attrs: {
        "title": module.name,
        "useAcordion": true,
        "useToggleIcon": true
      }
    }, [_c('panel', [(_vm.fetched) ? _c('div', {
      staticClass: "l-row"
    }, [_vm._l((_vm.getStatusByIdentifier(module.identifier)), function(statusValue, statusName) {
      return (statusName !== 'identifier' && statusName !== 'exchange') ? _c('form-group', {
        key: statusName,
        attrs: {
          "label": _vm.$t((statusName + ".label"))
        }
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getStatusByIdentifier(module.identifier)[statusName]),
          expression: "getStatusByIdentifier(module.identifier)[statusName]"
        }],
        staticClass: "form-select",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.getStatusByIdentifier(module.identifier), statusName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType[statusName]), function(status) {
        return _c('option', {
          key: status.code,
          domProps: {
            "value": status.code
          }
        }, [_vm._v(_vm._s(status.label))])
      })], 2)]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.getExchangeStatusByIdentifier(module.identifier)), function(statusValue, statusName) {
      return (_vm.haveExchangeStatuses(module.identifier)) ? _c('form-group', {
        key: statusName,
        attrs: {
          "label": _vm.$t(("exchange." + statusName + ".label"))
        }
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getExchangeStatusByIdentifier(module.identifier)[statusName]),
          expression: "getExchangeStatusByIdentifier(module.identifier)[statusName]"
        }],
        staticClass: "form-select",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.getExchangeStatusByIdentifier(module.identifier), statusName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType[statusName]), function(status) {
        return _c('option', {
          key: status.code,
          domProps: {
            "value": status.code
          }
        }, [_vm._v(_vm._s(status.label))])
      })], 2)]) : _vm._e()
    })], 2) : (!_vm.fetching) ? _c('div', {
      staticClass: "u-bolder t-error u-textCenter"
    }, [_vm._v("Não foi possível buscar os status dos pedidos da Moovin.")]) : _vm._e()])], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f1d2ea2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Moovin.vue
// module id = 2909
// module chunks = 0